/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_ForkedInputs */

const cs_templates_forked = /** @type {(inputs: Templates_ForkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona zkopírována`)
};

const en_templates_forked = /** @type {(inputs: Templates_ForkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template forked`)
};

/**
* | output |
* | --- |
* | "Template forked" |
*
* @param {Templates_ForkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_forked = /** @type {((inputs?: Templates_ForkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_ForkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_forked(inputs)
	return cs_templates_forked(inputs)
});